var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
      attrs: { "hide-overlay": true },
    },
    [
      _c(
        "button",
        {
          class: _vm.className,
          attrs: {
            slot: "activator",
            disabled: _vm.disabled,
            type: "button",
            id: "",
          },
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
          slot: "activator",
        },
        [_vm._v(_vm._s(_vm.$t("action.cancelAddendum")))]
      ),
      _vm._v(" "),
      _c(
        "modal",
        { ref: "modal", attrs: { modalId: "cancel-addendum-" + +new Date() } },
        [
          _c(
            "div",
            {
              staticClass: "modal-container",
              attrs: { id: "cancel-addendum-container" },
            },
            [
              _c("p", { staticClass: "modal-pure-text" }, [
                _vm._v(_vm._s(_vm.$t("warn.addendum.cancel"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("no")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.fallbackAddendum()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("yes")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }